export default function About() {
  return (
    <div data-testid="about-page">
      <section className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 pt-20 pb-12 text-center">
        <p className="font-accent text-4xl text-terracotta -rotate-2 mb-4">Mon Histoire</p>
        <h1 className="font-serif-display text-5xl sm:text-6xl leading-tight mb-6">
          Un fil, deux mains et beaucoup d'amour et de passion.
        </h1>
        <p className="text-lg text-[#6B655C] max-w-3xl mx-auto leading-relaxed">
          Labounite, c’est l’histoire d’un savoir-faire précieux. Chaque création prend vie au fil des mailles, façonnée avec patience, délicatesse et amour par une artisane passionnée, qui perpétue l’art traditionnel du crochet et du tricot transmis depuis deux générations.
        </p>
      </section>

      <section data-testid="artisan-portrait-section" className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-12 grid md:grid-cols-2 gap-10 items-center">
        <div className="aspect-[4/5] rounded-3xl overflow-hidden shadow-xl -rotate-1">
          <img data-testid="artisan-portrait-image" src="https://customer-assets-agu9un31.emergentagent.net/job_artisan-crafts-23/artifacts/e9c84bc923da198e_Portrait%20hivernal%20en%20montagne%20enneig%C3%A9e.webp" alt="Françoise, l'artisane de Labounite" className="w-full h-full object-cover object-top" />
        </div>
        <div className="flex flex-col justify-center bg-white/60 backdrop-blur-md rounded-3xl p-8 sm:p-10">
          <p className="font-accent text-3xl text-terracotta -rotate-2 mb-4">Le mot de l'artisane</p>
          <p data-testid="artisan-message" className="text-lg text-[#1F1C18]/85 leading-relaxed mb-4 text-justify hyphens-auto" lang="fr">
            « Se lancer à 47 ans n’a rien d’impossible. J’ai commencé par le crochet, en m’inspirant de ce que m’avaient appris ma mère et ma grand-mère, puis j’ai découvert le tricot afin de diversifier mes créations. J’aime apporter une touche de modernité à mon travail à travers les couleurs et les formes. Chacune des pièces que je crée porte en elle un peu de l’âme des montagnes et des saisons du Cantal. »
          </p>
          <p className="text-lg text-[#1F1C18]/85 leading-relaxed mb-6">
            Merci de faire vivre ce savoir-faire en accueillant mes créations chez vous.
          </p>
          <p data-testid="artisan-signature" className="font-accent text-4xl text-[#1F1C18] -rotate-3 self-end">Françoise ♡</p>
        </div>
      </section>

      <section className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-12 grid md:grid-cols-2 gap-10">
        <div className="flex flex-col justify-center order-2 md:order-1">
          <h2 className="font-serif-display text-4xl mb-5">L'<em className="text-terracotta">authenticité</em> du fait-main</h2>
          <p className="text-[#1F1C18]/80 leading-relaxed mb-4">
            Chaque pièce demande entre 8 et 40 heures de travail. Vous ne trouverez jamais deux articles identiques. C'est ce qui fait la beauté de l'artisanat : l'unicité.
          </p>
          <p className="font-accent text-3xl text-mustard -rotate-2">Fait avec amour ♡</p>
        </div>
        <div className="aspect-[4/5] rounded-3xl overflow-hidden order-1 md:order-2">
          <img data-testid="about-shawls-image" src="https://customer-assets-agu9un31.emergentagent.net/job_artisan-crafts-23/artifacts/0cc9e47b911c793a_Portant%20orn%C3%A9%20de%20ch%C3%A2les%20crochet%C3%A9s.webp" alt="Châles crochetés sur un portant" className="w-full h-full object-cover" />
        </div>
      </section>
    </div>
  );
}
